import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { connect } from "react-redux";
import { addToWishlist, removeFromWishlist } from "../../../redux/actions/wishlistActions";

const MenuWishList = ({ wishlistData, currency, removeFromWishlist }) => {

  const { addToast } = useToasts();

  return (
    <div className="shopping-cart-content">
      {wishlistData && wishlistData.length > 0 ? (
        <Fragment>
          <ul>
            {wishlistData.map((single, key) => {
              if (!single?.id) return null;
              return (
                <li className="single-shopping-cart" key={key}>
                  <div className="shopping-cart-img">
                    <Link to={process.env.PUBLIC_URL + "/product/" + single.id}>
                      <img
                        alt=""
                        src={global.baseUrlImage +  (single?.image?.[0] ?  single?.image?.[0] : single.variation[0].image[0])}
                        className="img-fluid"
                      />
                    </Link>
                  </div>
                  <div className="shopping-cart-title">
                    <h4>
                      <Link
                        to={process.env.PUBLIC_URL + "/product/" + single.id}
                      >
                        {single.sku}{" "}
                      </Link>
                    </h4>

                    <h4>
                      <Link
                        to={process.env.PUBLIC_URL + "/product/" + single.id}
                      >
                        {single.name}{" "}
                      </Link>
                    </h4>
                  </div>
                  <div className="shopping-cart-delete">
                    <button onClick={() => removeFromWishlist(single, addToast)}>
                      <i className="fa fa-times-circle" />
                    </button>
                  </div>
                </li>
              );
            })}
          </ul>

          <div className="shopping-cart-btn btn-hover text-center">
            <Link className="default-btn" to={process.env.PUBLIC_URL + "/wishlist"}>
              Visualizza Preferiti
            </Link>
          </div>
        </Fragment>
      ) : (
        <p className="text-center">Nessun articolo selezionato</p>
      )}
    </div>
  );
};

MenuWishList.propTypes = {
  wishlistData: PropTypes.array,
  currency: PropTypes.object,
  removeFromWishlist: PropTypes.func
};

const mapDispatchToProps = dispatch => {
  return {
    removeFromWishlist: (item, addToast) => {
      dispatch(removeFromWishlist(item, addToast));
    },
    addToWishlist: (item, addToast) => {
      dispatch(addToWishlist(item, addToast));
    },
  };
};

const mapStateToProps = state => {
  return {
    userData: state.userData,
    wishlistData: state.wishlistData,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuWishList);


